export default __webpack_public_path__ + "static/media/placeholder_dummy2016-restaurant03-de.ea3358a2.png";